/* eslint-disable */
<template>
  <div  id="tabs">

    <!--tabs for dashboard-->
    <v-tabs grow  v-if="activeView === 'Dashboard'">
        <v-tab>
          <v-icon class="margin-right-small">dashboard</v-icon>
          Home
        </v-tab>
        <v-tab>
          <v-icon class="margin-right-small">new_releases</v-icon>
          New Features
        </v-tab>
        <v-tab>
          <v-icon class="margin-right-small">live_help</v-icon>
          Help
        </v-tab>
    </v-tabs>

    <!--tabs for classes in instructor view-->
    <v-tabs grow   v-model="instructorActiveTab" v-if="activeView === 'Classes' && (activeViewInstructor === 'Bulbs' || activeViewInstructor === 'Gradebook' || activeViewInstructor === 'Learners')"  color="#fafafa" :slider-color="school.active_color">
        <v-tab @click="classTabNav(['Bulbs', {section_id: queryParamsInstructors.section_id, all_data: false}])" >
          <v-icon class="margin-right-small">lightbulb</v-icon>
          Bulbs
        </v-tab>
        <v-tab @click="classTabNav(['Gradebook',  {section_id: queryParamsInstructors.section_id, all_data: false} ])" >
          <v-icon class="margin-right-small">view_list</v-icon>
          Gradebook
        </v-tab>
        <v-tab @click="classTabNav(['Learners',  {section_id: queryParamsInstructors.section_id, all_data: false} ])" >
          <v-icon class="margin-right-small">people</v-icon>
          Learners
        </v-tab>
    </v-tabs>

    <!--tabs for premade view-->
    <v-tabs grow   v-model="premadeActiveTab" v-if="activeView === 'Premade-Bulbs'"  color="#fafafa" :slider-color="school.active_color">
        <v-tab @click="premadeTabNav(['My-Community', {}])" :disabled="disableMyCommunity">
          <v-icon style="padding-right: 10px;">group</v-icon>
          {{myCommunityName}}
        </v-tab>
        <v-tab @click="premadeTabNav(['Premade-Bulbs',  {} ])" >
          <v-icon style="padding-right: 10px;">shop</v-icon>
          All PlayPosit
        </v-tab>
    </v-tabs>

    <!--tabs for classes in learner view-->
    <v-tabs
      grow
      v-model="learnerActiveTab"
      v-if="activeView === 'Learner' && (activeViewLearners === 'Bulbs' || activeViewLearners === 'Gradebook' || activeViewLearners === 'Playlists')"
      color="#fafafa"
      :slider-color="school.active_color">
        <v-tab
          @click="learnerData.migrated ? null : learnerTabNav(['Bulbs', {section_id: queryParamsLearners.section_id}])"
          @keyup.enter.native="learnerData.migrated ? null : learnerTabNav(['Bulbs', {section_id: queryParamsLearners.section_id}])"  
          class="learner-tabs tabable-first"
          tabindex="1"
          :aria-label="createAriaLabel('bulbs')"
          :disabled="!!learnerData.migrated || learnersAjaxing"
        >
          <v-icon class="margin-right-small">lightbulb</v-icon>
          Bulbs
        </v-tab>
        <v-tab
          @click="learnerData.migrated ? null : learnerTabNav(['Playlists', {section_id: queryParamsLearners.section_id}])"
          @keyup.enter.native="learnerData.migrated ? null : learnerTabNav(['Playlists', {section_id: queryParamsLearners.section_id}])"
          class="learner-tabs tabable-first"
          tabindex="1"
          :aria-label="createAriaLabel('playlists')"
          :disabled="!!learnerData.migrated || learnersAjaxing"
        >
          <v-icon class="margin-right-small">playlist_play</v-icon>
          Playlists
        </v-tab>
        <v-tab
          @click="learnerTabNav(['Gradebook',  {section_id: queryParamsLearners.section_id} ])"
          @keyup.enter.native="learnerTabNav(['Gradebook',  {section_id: queryParamsLearners.section_id} ])"  class="learner-tabs tabable-first"
          tabindex="1"
          :aria-label="createAriaLabel('gradebook')"
          :disabled="learnersAjaxing"
        >
          <v-icon class="margin-right-small">view_list</v-icon>
          Gradebook
        </v-tab>
    </v-tabs>

    <!--tabs for admin view-->
    <v-tabs grow   v-model="adminActiveTab" v-if="activeView === 'Administration' && (activeViewAdmin === 'Snapshot' || activeViewAdmin === 'Schools' || activeViewAdmin === 'Instructors' || activeViewAdmin === 'Bulbs' || activeViewAdmin === 'Treeview' || activeViewAdmin === 'Classes' || activeViewAdmin === 'Videos')"  color="#fafafa" :slider-color="school.active_color">
        <v-tab @click="adminTabNav(['Snapshot', {}])" >
          <v-icon class="margin-right-small">dashboard</v-icon>
          Admin Snapshot
        </v-tab>
        <v-tab @click="adminTabNav(['Schools', {}])" >
          <v-icon class="margin-right-small">business</v-icon>
          Organizations
        </v-tab>
        <v-tab @click="adminTabNav(['Instructors', {}])" >
          <v-icon class="margin-right-small">person</v-icon>
          All Instructors
        </v-tab>
        <v-tab @click="_.get(school, 'config.permissions', []).includes('adminTreeview') ? adminTabNav(['Treeview', {}]) : adminTabNav(['Bulbs', {}])" >
          <v-icon class="margin-right-small">lightbulb</v-icon>
          Media Library
        </v-tab>
    </v-tabs>

    <!--small breadcrumbs for gradebook in instructor view-->
    <div v-if="(activeView === 'Classes' && (activeViewInstructor === 'Interactions' || activeViewInstructor === 'Student-Bulb-Attempts' || activeViewInstructor === 'Single-Interaction' || activeViewInstructor === 'Student-Interaction' || activeViewInstructor === 'Learner-Made-Bulb' || activeViewInstructor === 'Learner-Made-Bulb-Monitor' || activeViewInstructor === 'Peer-Review')) || (activeView === 'My-Bulbs' && activeViewInstructor === 'Interactions')">
      <v-breadcrumbs class="gradebook-breadcrumbs">
        <v-icon slot="divider">chevron_right</v-icon>
        <v-breadcrumbs-item
          v-for="item in gradebookBreadcrumbs"
          :disabled="item.payload === ''"
          :key="item.text"
          :class="(item.payload === '') ? '' : 'active'"
          @click.native="breadcrumbLink(item.payload)"
        >
          <div >{{ item.text }}</div>
        </v-breadcrumbs-item>
        <template v-if="activeViewInstructor === 'Single-Interaction' && singleInteractionData.interaction_type != ''" >
          <div
            class="question-header"
            v-for="(interactionBank, index) in (singleinteraction.headers.interactionBanks || [{interactionId: singleInteractionData.id}])"
            :class="index === 0 ? 'ml-3' : 'ml-1'"
          >
            <el-popover v-model="menus.singleInteraction[parseInt(interactionBank.interactionId, 10)]" trigger="click" placement="right"  width="375">
              <div class="popover-content-wrapper">
                <PlaypositInteraction
                  v-if="menuData.singleInteraction[parseInt(interactionBank.interactionId, 10)]"
                  :bulb-id="parseInt($route.query.bulb_id, 10)"
                  :section-id="parseInt($route.query.section_id, 10)"
                  :interaction-id="parseInt(interactionBank.interactionId, 10)"
                  :token="instructorData.token"
                  topper="typeAndTimestamp"
                  user-type="teacher"
                  discussion-role="observer"
                  perspective="displayMaximum"
                />
              </div>
              <el-tag type="info" slot="reference" class="question-tag">
                <v-icon class="cursor">{{questionFormat(singleInteractionData).icon}}</v-icon>
              </el-tag>
            </el-popover>
          </div>
        </template>
      </v-breadcrumbs>

    </div>

    <!--small breadcrumbs for gradebook in learner view-->
    <div v-if="activeView === 'Learner' && (activeViewLearners  === 'Student-Interaction' || activeViewLearners  === 'LMB-Monitor')">
      <v-breadcrumbs class="gradebook-breadcrumbs">
        <v-icon slot="divider">chevron_right</v-icon>
        <v-breadcrumbs-item
          v-for="item in learnerGradebookBreadcrumbs"
          :disabled="item.payload === ''"
          :key="item.text"
          :class="(item.payload === '') ? '' : 'active'"
          @click.native="breadcrumbLink(item.payload)"
        >
          <div >{{ item.text }}</div>
        </v-breadcrumbs-item>
      </v-breadcrumbs>
    </div>
  </div>
</template>

<script>
import {
  mapState,
  mapGetters,
  mapMutations,
} from 'vuex';

import {
  INTERACTION_TYPES,
} from '@Constants';

export default {
  name: 'tabs',
  components: {
  },
  data() {
    return {
      instructorActiveTab: null,
      learnerActiveTab: null,
      premadeActiveTab: null,
      adminActiveTab: null,
      menus: {
        singleInteraction: {},
      },
      menuData: {
        singleInteraction: {},
      },
    };
  },
  computed: {
    ...mapState('instructors', [
      'embedded',
    ]),
    ...mapState('learners', [
      'attemptGetPlaylists',
      'learnerSectionHasPlaylist',
      'learnerSectionPlaylists',
    ]),
    ...mapGetters( [
    'activeView',
    'breadcrumbs',
    'breadcrumbPayloads',
    'userDataLoaded',
    'stateDataLoaded',
    'instructorData',
    'learnerData',
    'popoverToggles',
    'school'
  ]),
    ...mapGetters('instructors', [
    'activeViewInstructor',
    'classes',
    'bulbs',
    'premade',
    'bulbattempts',
    'selectedData',
    'queryParamsInstructors',
    'gradebookBreadcrumbs',
    'instructorAjaxing',
    'singleinteraction'
  ]),
  ...mapGetters('learners', [
    'activeViewLearners',
    'queryParamsLearners',
    'learnersAjaxing',
    'learnerGradebookBreadcrumbs'
  ]),
  ...mapGetters('admin', [
    'activeViewAdmin',
    'queryParamsAdmin',
    'adminAjaxing',
  ]),

   singleInteractionData: function(){
     //get single interaction data for question display in tabs
     if(this.activeViewInstructor === 'Single-Interaction'){
       let data = {
         id: this.singleinteraction.headers.id,
         interaction_type: this.singleinteraction.headers.interactionType,
         interaction_text: this.singleinteraction.headers.interactionText,
         interaction_options: this.singleinteraction.headers.interactionOptions,
         config: this.singleinteraction.headers.config,
       };
       return  data;
     }
   },
   disableMyCommunity: function(){
     if(this.school.id){
       return false;
     } else {
       return true;
     }
   },
   myCommunityName: function(){
     if(this.school.id){
       if(this.school.master_district) {
        return `${this.school.master_district.name} Media`;
       } else {
        return `${this.school.name} Media`;
       }
     } else {
       return 'My Community';
     }
   }
  },
  methods:{
    ...mapMutations('admin', [
      'clearSelectedData',
    ]),
    //helper functions
    addCommas:function(num){
     //add commas to numbers
     if(num) return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    loadActiveTab: function(){
      //sets active tab for instructors based on active view in initial load
      if(this.activeViewInstructor === 'Bulbs') {
         this.instructorActiveTab= 0;
       } else if(this.activeViewInstructor === 'Gradebook' ){
         this.instructorActiveTab= 1;
       } else if(this.activeViewInstructor === 'Learners'){
         this.instructorActiveTab= 2;
       } else if(this.activeViewInstructor === 'Premade-Bulbs'){
         this.premadeActiveTab= 1;
       } else if(this.activeViewInstructor === 'Premade-Bulbs-Legacy'){
         this.premadeActiveTab= 1;
       } else if(this.activeViewInstructor === 'My-Community'){
         this.premadeActiveTab= 0;
       } else if(this.activeViewInstructor === 'My-Community-Legacy'){
         this.premadeActiveTab= 0;
       } else{
         this.instructorActiveTab= null;
       }
       //sets active tab for learners based on active view in initial load
       if (this.activeViewLearners === 'Bulbs') {
         this.learnerActiveTab = 0;
       } else if (this.activeViewLearners === 'Playlists'){
         this.learnerActiveTab = 1;
       } else if (this.activeViewLearners === 'Gradebook') {
         this.learnerActiveTab = 2;
       } else {
         this.learnerActiveTab= null;
       }

       if(this.activeViewAdmin === 'Snapshot'){
         this.adminActiveTab = 0;
       } else if(this.activeViewAdmin === 'Schools'){
         this.adminActiveTab = 1;
       } else if(this.activeViewAdmin === 'Instructors'){
         this.adminActiveTab = 2;
       } else if(this.activeViewAdmin === 'Bulbs'){
         this.adminActiveTab = 3;
       } else if(this.activeViewAdmin === 'Treeview'){
         this.adminActiveTab = 3;
       }
    },
    createAriaLabel:function(type){
      return `Navigation to ${type} for ${this.breadcrumbs[1].text}. Press enter to show the ${type} table.`;
    },
    
    closeFilters: function(){
      this.popoverToggles.filterMenu = false;
      this.popoverToggles.snapshot = false;
      this.popoverToggles.adminFilterMenu= false;
    },
    //navigation functions
    classTabNav: function(array) {
      //nav for class tabs in instructor view
      //sets active view and params
      let active_view = array[0];
      let query_params = array [1];
      //check if lms class and keep toggle to true in query params
      if(this.queryParamsInstructors.lms_class){
        query_params['lms_class'] = true;
      }
      if (this.embedded) {
        query_params['embed'] = true;
      }
      this.closeFilters();
      //reset query params, set query params, set instructor active view, and update Url
      this.$store.commit('instructors/resetQueryParams');
      this.$store.commit('instructors/clearAllFiltersNoReload');
      this.$store.commit('instructors/setQueryParams', query_params);
      this.$store.commit('instructors/setActiveView', [active_view]);
      this.$store.dispatch('instructors/updateUrl');
    },
    async handleSwitchToPlaylistTab() {
      this.learnerTabNav(['Playlists', {section_id: this.queryParamsLearners.section_id}]);
      this.learnerActiveTab = 1;
    },
    premadeTabNav: function(array) {
      //nav for class tabs in premade view
      //sets active view and params
      let active_view = array[0];
      let query_params = array [1];
      this.closeFilters();
      //reset query params, set query params, set instructor active view, and update Url
      this.$store.commit('instructors/resetQueryParams');
      this.$store.commit('instructors/clearAllFiltersNoReload');
      this.$store.commit('instructors/setQueryParams', query_params)
      this.$store.commit('instructors/setActiveView', [active_view]);
      this.$store.dispatch('instructors/updateUrl');
    },
    learnerTabNav: function(array) {
      //nav for class tabs in learner view
      //sets active view and params
      let active_view = array[0];
      let query_params = array [1];
      this.closeFilters();
      //reset query params, set query params, set learner active view, and update Url
      this.$store.commit('learners/resetQueryParams');
      this.$store.commit('learners/setQueryParams', query_params)
      this.$store.commit('learners/setActiveView', [active_view]);
      this.$store.dispatch('learners/updateUrl');
    },
    adminTabNav: function(array) {
      //nav for class tabs in learner view
      //sets active view and params
      let active_view = array[0];
      let query_params = array [1];
      this.closeFilters();
      //reset query params, set query params, set learner active view, and update Url
      this.$store.commit('admin/resetQueryParams');
      this.$store.commit('admin/clearAllFiltersNoReload');
      this.$store.commit('admin/setActiveView', [active_view]);
      this.$store.commit('admin/setQueryParams', query_params);
      this.$store.dispatch('admin/updateUrl');
      if (active_view !== 'Treeview' || active_view !== 'Bulbs') this.clearSelectedData();
    },
    breadcrumbLink: function(name) {
      //handle gradebook breadcrumb link
      //finds payload in main state
      if(name){
        let payload= this.breadcrumbPayloads[name]
        this.closeFilters();
        //uses payload to set data
        if(payload.route === "instructor"){
          //sets saved gradebook breadcrumb, query params, and active view
          this.$store.commit('instructors/setGradebookBreadcrumbs' , payload.breadcrumb);
          this.$store.commit('instructors/clearAllFiltersNoReload');
          this.$store.commit('instructors/setQueryParams', payload.queryParams);
          this.$store.commit('instructors/setActiveView', [payload.activeViewRoute]);
          //updates url
          this.$store.dispatch('instructors/updateUrl');
        }
      }

    },
    questionFormat: function(data) {

      let questionObject = {};

      switch(data.interaction_type) {
        case INTERACTION_TYPES.MULTIPLE_CHOICE:
          questionObject.type = 'Multiple Choice';
          questionObject.icon = 'format_list_bulleted';

          //create list items for answers and feedback
          let answerArrayMC= [];
          data.interaction_options.forEach((answer, i) => {
            if(answer.correct === 1){
              (answer.feedback === null || answer.feedback === '') ? answerArrayMC.push(`<li><span class="dot-correct"></span>${answer.option}</li>`) : answerArrayMC.push(`<li><span class="dot-correct"></span>${answer.option}</li><li class='feedback'><span style="margin-right: 5px; font-weight:bold;">Feedback:</span><span> ${answer.feedback}</span></li>`);
            } else {
              (answer.feedback === null || answer.feedback === '') ? answerArrayMC.push(`<li><span class="dot-incorrect"></span>${answer.option}</li>`) : answerArrayMC.push(`<li><span class="dot-incorrect"></span>${answer.option}</li><li class='feedback'><span style="margin-right: 5px; font-weight:bold;">Feedback:</span><span>${answer.feedback}</span></li>`);
            }
          })

          //join list items and add to questionHTML
          let answersMC = answerArrayMC.join(' ');
          questionObject.questionHTML = `<div class="question-format">${data.interaction_text}</div><div class="question-format"><ul>${answersMC}</ul></div>`

          break;
        case INTERACTION_TYPES.CHECK_ALL_APPLY:
          questionObject.type = 'Check All';
          questionObject.icon = 'playlist_add_check';

            //create list items for answers and feedback
            let answerArrayCA= [];
            data.interaction_options.forEach((answer, i) => {
              if(answer.correct === 1){
                (answer.feedback === null || answer.feedback === '') ? answerArrayCA.push(`<li><span class="dot-correct"></span>${answer.option}</li>`) : answerArrayCA.push(`<li><span class="dot-correct"></span>${answer.option}</li><li class='feedback'><span style="margin-right: 5px; font-weight:bold;">Feedback:</span> ${answer.feedback}</li>`);
              } else {
                (answer.feedback === null || answer.feedback === '') ? answerArrayCA.push(`<li><span class="dot-incorrect"></span>${answer.option}</li>`) : answerArrayCA.push(`<li><span class="dot-incorrect"></span>${answer.option}</li><li class='feedback'><span style="margin-right: 5px; font-weight:bold;">Feedback:</span> ${answer.feedback}</li>`);
              }
            })

            //join list items and add to questionHTML
            let answersCA = answerArrayCA.join(' ');
            questionObject.questionHTML = `<div class="question-format">${data.interaction_text}</div><div class="question-format"><ul>${answersCA}</ul></div>`

          break;
        case INTERACTION_TYPES.FREE_RESPONSE:
          questionObject.type = 'Free Response';
          questionObject.icon = 'border_color';
          questionObject.questionHTML = `<div class="question-format">${data.interaction_text}</div>`
          if(data.config){
            if(data.config.feedback){
              questionObject.questionHTML += `<ul style="list-style: none"><li class='feedback'><span style="margin-right: 5px; font-weight:bold;">Feedback:</span> ${data.config.feedback}</li></ul>`
            }
          }

          break;
        case INTERACTION_TYPES.SHORT_ANSWER:
          questionObject.type = 'Fill in the blank';
          questionObject.icon = 'subtitles';

            let answerArraySA= [];
            data.interaction_options.forEach((answer, i) => {
              if(answer.feedback === null || answer.feedback === ''){
                answerArraySA.push(`<li><i data-v-48ddbe66="" aria-hidden="true" class="v-icon material-icons theme--light" style="margin-right:10px;">subtitles</i>${answer.option}</li>`);
              } else {
                answerArraySA.push(`<li><i data-v-48ddbe66="" aria-hidden="true" class="v-icon material-icons theme--light" style="margin-right:10px;">subtitles</i>${answer.option}</li><li class='feedback'><span style="margin-right: 5px; font-weight:bold;">Feedback:</span> ${answer.feedback}</li>`);
              }
            })

            let answersSA = answerArraySA.join(' ');
            let question = data.interaction_text.replace(/fill in blank/g,'______________________');
            questionObject.questionHTML = `<div class="question-format">${question}</div><div class="question-format"><ul>${answersSA}</ul></div>`

          break;
        case INTERACTION_TYPES.PAUSE:
          questionObject.type = 'Pause';
          questionObject.icon = 'bookmark_border';
          questionObject.questionHTML = `<div class="question-format">${data.interaction_text}</div>`

          break;
        case INTERACTION_TYPES.IFRAME:
          questionObject.type = 'Embedded';
          questionObject.icon = 'public';
          questionObject.questionHTML = `<div class="question-iframe"><iframe src="${decodeURIComponent(data.interaction_text)}"></iframe></div>`

          break;
        case INTERACTION_TYPES.FILE_VIEWER:
          questionObject.type = 'PDF Viewer';
          questionObject.icon = 'picture_as_pdf';
          questionObject.questionHTML = `<div class="question-iframe"><iframe src="${decodeURIComponent(data.interaction_text)}"></iframe></div>`

          break;
        case INTERACTION_TYPES.POLL:
          questionObject.type = 'Poll';
          questionObject.icon = 'poll';

          let answerArrayP= [];
            data.interaction_options.forEach((answer, i) => {
            if(answer.feedback === null ){
                answerArrayP.push(`<li><span class="dot-incorrect"></span>${answer.option}</li>`);
              } else {
                answerArrayP.push(`<li><span class="dot-incorrect"></span>${answer.option}</li><li class='feedback'><span style="margin-right: 5px; font-weight:bold;">Feedback:</span> ${answer.feedback}</li>`);
              }
            })

            let answersP = answerArrayP.join(' ');
            questionObject.questionHTML = `<div class="question-format">${data.interaction_text}</div><div class="question-format"><ul>${answersP}</ul></div>`
          break;
        case INTERACTION_TYPES.DISCUSSION:
          questionObject.type = 'Discussion';
          questionObject.icon = 'chat';
          questionObject.questionHTML = `<div class="question-format">${data.interaction_text}</div>`
          break;
        default:
          questionObject.type = 'Question';
          questionObject.icon = 'question_answer';
          break;
      }

      return questionObject;
    },
  },
  watch: {
    activeViewInstructor: {
      handler: function(val, oldVal){
      //set instructor tab for nav selection
      if(this.activeViewInstructor === 'Bulbs') {
         this.instructorActiveTab= 0;
       } else if(this.activeViewInstructor === 'Gradebook' ){
         this.instructorActiveTab= 1;
       } else if(this.activeViewInstructor === 'Learners'){
         this.instructorActiveTab= 2;
       } else if(this.activeViewInstructor === 'Premade-Bulbs'){
         this.premadeActiveTab= 1;
       } else if(this.activeViewInstructor === 'Premade-Bulbs-Legacy'){
         this.premadeActiveTab= 1;
       } else if(this.activeViewInstructor === 'My-Community'){
         this.premadeActiveTab= 0;
       } else if(this.activeViewInstructor === 'My-Community-Legacy'){
         this.premadeActiveTab= 0;
       } else{
         this.instructorActiveTab= null;
       }
      }
    },
    activeViewLearners: {
      handler: function(val, oldVal){
        //set learner tab for nav selection
        if (this.activeViewLearners === 'Bulbs') {
          this.learnerActiveTab = 0;
         } else if(this.activeViewLearners === 'Playlists') {
           this.learnerActiveTab = 1;
         } else if (this.activeViewLearners === 'Gradebook') {
           this.learnerActiveTab = 2;
         } else {
           this.learnerActiveTab= null;
         }
      }
    },
    activeViewAdmin: {
      handler: function(val){
         if(this.activeViewAdmin === 'Snapshot'){
           this.adminActiveTab = 0;
         } else if(this.activeViewAdmin === 'Schools'){
           this.adminActiveTab = 1;
         } else if(this.activeViewAdmin === 'Instructors'){
           this.adminActiveTab = 2;
         } else if(this.activeViewAdmin === 'Bulbs'){
           this.adminActiveTab = 3;
         }
      }
    },
    attemptGetPlaylists(n) {
      if (n) this.handleSwitchToPlaylistTab();
    },
    menus: {
      handler(n, o) {
        for (const key in n) {
          for (const innerKey in n[key]) {
            if (n[key][innerKey]) {
              this.menuData[key][innerKey] = true;
            }
          }
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.loadActiveTab()
  },
  updated() {
    this.loadActiveTab();
  },
};
</script>

<style scoped>
</style>
